import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../core/store/reducers";
import { loadSecurityFForSelect } from "../../../data/initialData/thunks/loadSecurityFForSelect";
import { SecuritySimpleList } from "../../../data/initialData/types";
import { useDisplayMarketData } from "../../../data/foreign/mainBoard/hooks/useDisplayMarketData";
import { DisplayDrawerContext } from "../../../layout/DisplayDrawerContext";
import { FMarketListData } from "../../../data/foreign/mainBoard/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { DisplayMarketDataMainAttributes, DiplayMarketDataMod } from "./DisplayMarketDataMainAttributes";
import { ExpansionPanel, ExpansionPanelSummary, Typography, Grid, IconButton } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useOrderPrinter } from "../../../data/foreign/orders/hooks/useOrderPrinter";
import { CustomTooltip } from "../../components/common/CustomTooltip";
import DownloadIcon from "@material-ui/icons/CloudDownloadOutlined";
import { useToggleStateDictionary } from "../../../core/util/hooks";
import { DisplaySecurityValuation } from "./DisplaySecurityValuation";
import { DisplaySecurityStatistics } from "./DisplaySecurityStatistics";
import { DisplaySecurityEarnings } from "./DisplaySecurityEarnings";
import { DisplaySecurityEarningsEstimate } from "./DisplaySecurityEarningsEstimate";
import { DisplaySecurityRevenueEstimate } from "./DisplaySecurityRevenueEstimate";
import { DisplaySecurityEpsTrend } from "./DisplaySecurityEPSTrend";
import { DisplayEtfSummary } from "./DisplayEtfSummary";
import { DisplayEtfComposition } from "./DisplayEtfComposition";
import { DisplayEtfPerformance } from "./DisplayEtfPerformance";

enum AccordionNames {
	BasicInfo = "basicInfo",
	Statistics = "statistics",
	Valuation = "valuation",
	Earnings = "earnings",
	Earestimate = "earestimate",
	Revestimate = "revestimate",
	Epstrend = "epstrend",
	EtfSummary = "etfsummary",
	EtfComposition = "etfcomposition",
	EtfPerformance = "etfperformance",
}

const accordionNames = Object.values(AccordionNames);

export interface DisplayMDProps {
	id: string;
	displayMod: DiplayMarketDataMod;
	enablePrint?: boolean;
}

export const DisplayMarketData: React.FunctionComponent<DisplayMDProps> = ({
	id,
	displayMod,
	enablePrint,
}) => {

	//	console.log(id)
	//	console.log(displayMod)

	const marketdata = useDisplayMarketData(id);
	const { getString } = React.useContext(LocalizationContext);
	//	const [print, fetchState] = useOrderPrinter(marketdata);

	const [open, toggleOpen] = useToggleStateDictionary(accordionNames, [AccordionNames.BasicInfo]);

	const dispatch = useDispatch();

	const selectSecurities = useSelector<
		StoreType,
		SecuritySimpleList[] | undefined | "loading"
	>((store) => store.data.initialData.securityFForSelect);

	// ako lista nije učitana — dovuci je
	React.useEffect(() => {
		if (!selectSecurities) {
			dispatch(loadSecurityFForSelect("F")); // stavi pravi df
		}
	}, [dispatch, selectSecurities]);

	// ovde nalazimo secTypeId
	const secTypeId = React.useMemo(() => {
		if (!selectSecurities || selectSecurities === "loading") return undefined;

		const item = selectSecurities.find(x => x.securityId === id);
		return item?.secTypeId;
	}, [selectSecurities, id]);

	const isEtf = secTypeId === "00000062" || secTypeId === "00000063";

	console.log(marketdata)

	return !marketdata || !marketdata.symbol ? (
		<>{"loading placeholder"}</>
	) : (
		<Grid container justify="center" direction="column">
			<ExpansionPanel
				expanded={open[AccordionNames.BasicInfo]}
				onChange={toggleOpen[AccordionNames.BasicInfo]}>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
					<Typography>{getString("tableBasciInfo")}</Typography>
				</ExpansionPanelSummary>
				<DisplayMarketDataMainAttributes marketdata={marketdata} mod={displayMod} />
			</ExpansionPanel>
			{!isEtf && (
				<>
					<ExpansionPanel
						expanded={open[AccordionNames.Statistics]}
						onChange={toggleOpen[AccordionNames.Statistics]}>
						<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
							<Typography>{getString("dispstatistics")}</Typography>
						</ExpansionPanelSummary>
						{open[AccordionNames.Statistics] && (
							<DisplaySecurityStatistics symbol={marketdata.symbol} />
						)}
					</ExpansionPanel>
					<ExpansionPanel
						expanded={open[AccordionNames.Valuation]}
						onChange={toggleOpen[AccordionNames.Valuation]}>
						<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
							<Typography>{getString("dispvaluation")}</Typography>
						</ExpansionPanelSummary>
						{open[AccordionNames.Valuation] && (
							<DisplaySecurityValuation symbol={marketdata.symbol} />
						)}
					</ExpansionPanel>
				</>
			)}
			{isEtf && (
				<>
					<ExpansionPanel
						expanded={open[AccordionNames.EtfSummary]}
						onChange={toggleOpen[AccordionNames.EtfSummary]}>
						<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
							<Typography>{getString("dispetfsummary")}</Typography>
						</ExpansionPanelSummary>
						{open[AccordionNames.EtfSummary] && (
							<DisplayEtfSummary symbol={marketdata.symbol} />
						)}
					</ExpansionPanel>
					<ExpansionPanel
						expanded={open[AccordionNames.EtfComposition]}
						onChange={toggleOpen[AccordionNames.EtfComposition]}>
						<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
							<Typography>{getString("dispetfcomposition")}</Typography>
						</ExpansionPanelSummary>
						{open[AccordionNames.EtfComposition] && (
							<DisplayEtfComposition symbol={marketdata.symbol} />
						)}
					</ExpansionPanel>
					<ExpansionPanel
						expanded={open[AccordionNames.EtfPerformance]}
						onChange={toggleOpen[AccordionNames.EtfPerformance]}>
						<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
							<Typography>{getString("dispetfperformace")}</Typography>
						</ExpansionPanelSummary>
						{open[AccordionNames.EtfPerformance] && (
							<DisplayEtfPerformance symbol={marketdata.symbol} />
						)}
					</ExpansionPanel>
				</>)}
			<ExpansionPanel
				expanded={open[AccordionNames.Earnings]}
				onChange={toggleOpen[AccordionNames.Earnings]}>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
					<Typography>{getString("dispearnings")}</Typography>
				</ExpansionPanelSummary>
				{open[AccordionNames.Earnings] && (
					<DisplaySecurityEarnings symbol={marketdata.symbol} />
				)}
			</ExpansionPanel>
			<ExpansionPanel
				expanded={open[AccordionNames.Earestimate]}
				onChange={toggleOpen[AccordionNames.Earestimate]}>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
					<Typography>{getString("dispearestimate")}</Typography>
				</ExpansionPanelSummary>
				{open[AccordionNames.Earestimate] && (
					<DisplaySecurityEarningsEstimate symbol={marketdata.symbol} />
				)}
			</ExpansionPanel>
			<ExpansionPanel
				expanded={open[AccordionNames.Revestimate]}
				onChange={toggleOpen[AccordionNames.Revestimate]}>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
					<Typography>{getString("disprevestimate")}</Typography>
				</ExpansionPanelSummary>
				{open[AccordionNames.Revestimate] && (
					<DisplaySecurityRevenueEstimate symbol={marketdata.symbol} />
				)}
			</ExpansionPanel>
			<ExpansionPanel
				expanded={open[AccordionNames.Epstrend]}
				onChange={toggleOpen[AccordionNames.Epstrend]}>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
					<Typography>{getString("dispepstrend")}</Typography>
				</ExpansionPanelSummary>
				{open[AccordionNames.Epstrend] && (
					<DisplaySecurityEpsTrend symbol={marketdata.symbol} />
				)}
			</ExpansionPanel>

		</Grid>
	);
};

export const useViewMarketData = (displayMod: DiplayMarketDataMod, enablePrint?: boolean) => {
	const showWithDrawer = React.useContext(DisplayDrawerContext);
	return React.useCallback(
		(marketdata: FMarketListData) => showWithDrawer(<DisplayMarketData id={marketdata.securityId} displayMod={displayMod} enablePrint={enablePrint} />),
		[showWithDrawer, displayMod]
	);
};

